import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-contact-view-modal',
    templateUrl: './contact-view-modal.component.html',
    styles: [],
})
export class ContactViewModalComponent implements OnInit {
    constructor(public activeModal: NgbActiveModal) {}

    contact: any;

    ngOnInit(): void {}
}
